import { createSlice } from "@reduxjs/toolkit";
import { NewsletterState } from "./newsletter.state";
import { postNewsletter } from "./newsletter.thunk";

const initialState: NewsletterState = {
  loadingType: null,
};

export const newsletterSlice = createSlice({
  name: "newsletter",
  initialState,
  reducers: {},
  extraReducers: (build) => {
    build
      .addCase(postNewsletter.pending, (state, action) => {
        state.loadingType = action.meta.arg.type;
      })
      .addCase(postNewsletter.fulfilled, (state) => {
        state.loadingType = null;
      })
      .addCase(postNewsletter.rejected, (state) => {
        state.loadingType = null;
      });
  },
});

export default newsletterSlice.reducer;
